import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables

const RefPd = () => {
    useEffect(() => {
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
    $('.table').DataTable({
        ajax: {
            url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getpd`,
            type: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
            },
            dataSrc: function(json) {
                if (!json.data || json.data.length === 0) {
                    return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                }
                return json.data;
            }
        },
        columns: [
            { 
                data: null, 
                render: function (data, type, row, meta) {
                    return meta.row + 1; // Menampilkan nomor urut
                }
            }, 
            { 
                data: null,
                render: function (data, type, row, meta) {
                    return `<b>${data.nama}</b>`;
                }
            },
           
          
        ],
        destroy: true,
        dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
        language: {
            search: "",
            lengthMenu: "_MENU_",
            emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
            loadingRecords: "Loading....", // Ganti teks "Loading..."
            zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
        },
    });
    return () => {
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
    };
}, []);


    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Peserta Didik / Murid</h3></div>

                                        <div className='col-auto'>
                                            {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button> */}
                                        </div>
                                    </div>
                                    <hr />
                                    {/* Tabel kelas */}
                                    <table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Nama</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                        </tbody>
                                    </table>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default RefPd;
